import styled from "styled-components";
import {transition} from "helpers/css";

export const SectionTitle = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #4F4F51;
  margin-bottom: 6px;
`;

export const Title = styled.div`
  max-width: 402px;
  font-size: 36px;
  font-weight: 600;
  line-height: 50px;
  letter-spacing: 0.01em;

  span {
    color: #3264EF;
    
    &::before,
    &::after {
      content: ' ';
    }
  }

  @media screen and (max-width: 1270px) {
    font-size: 24px;
    font-weight: 600;
    line-height: 34px;
    letter-spacing: 0.01em;
  }
`

export const Button = styled.a<{primary?: boolean}>`
  display: block;
  width: max-content;
  
  font-size: 15px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.01em;

  border-radius: 5px;
  padding: 16px 30px;
  text-align: center;

  background: #3264EF;
  color: white;

  ${transition()};
  cursor: pointer;
  
  &:hover {
    box-shadow: 10px 10px 20px rgba(50, 100, 239, 0.3);
  }
`